import React, { useCallback, useState } from 'react'

import { toggleShortlists } from '@disco/state-management/actions/AppActions'
import { createShowcase } from '@disco/state-management/actions/ShortlistActions'

import type { ArtistId } from 'types/artist'

import Button from 'components/ui/button'
import Tooltip from 'components/ui/tooltip'

import { useDispatch, useSelector } from 'hooks/use-redux'

type Props = {
  artistId: ArtistId
  disabled?: boolean
  onClick: () => void
}

const CreateShowcaseButton = ({ artistId, disabled, onClick }: Props) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const isPlaylistCreatorOpen = useSelector(state => state.app.shortlistsOpen)
  const handleClick = useCallback(async () => {
    if (artistId) {
      setIsLoading(true)

      try {
        await dispatch(createShowcase(artistId))

        if (!isPlaylistCreatorOpen) {
          dispatch(toggleShortlists(true, 'Explorer', 'Generate Showcase'))
        }

        onClick()
      } catch (error) {
        console.error('Failed to create showcase:', error)
      } finally {
        setIsLoading(false)
      }
    }
  }, [artistId, dispatch, isPlaylistCreatorOpen, onClick])
  return (
    <Tooltip
      content={
        disabled
          ? 'This artist has too many tracks to automatically generate a Page. You can create a Page for this artist in the Presentation tab when saving a playlist.'
          : null
      }
    >
      <Button
        caption="Click here"
        disabled={disabled}
        progressCaption="Generating"
        progressIndicator={isLoading}
        onClick={handleClick}
      />
    </Tooltip>
  )
}

export default React.memo<Props>(CreateShowcaseButton)
